import communication from './communication.config';
import header from './header.config';

export default {
  useRouter: true,
  // header,
  communication,
};
